module.exports = __webpack_public_path__ + "img/img_guanyuwomen_xinxingxin@3x.e653ad79.png";